// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M0 3H24V18H19.9539L22.6518 20.0631L21.4369 21.6518L16.6615 18H7.3347L2.56374 21.6519L1.34811 20.0637L4.04425 18H0V3Z"}}]};

const Tv1FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'tv-1-filled',
    ref,
    icon: element,
  },
));

Tv1FilledIcon.displayName = 'Tv1FilledIcon';

export default Tv1FilledIcon;
